import _defineProperty from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useTheme } from '@mui/material/styles';
import mergeAll from 'lodash/fp/mergeAll';
import { createMakeAndWithStyles } from 'tss-react';
/** Replacement @material-ui v4 makeStyles, withStyles */

var _createMakeAndWithSty = createMakeAndWithStyles({
  useTheme: useTheme
}),
    makeStyles = _createMakeAndWithSty.makeStyles,
    withStyles = _createMakeAndWithSty.withStyles;
/** (Deep) Merges 2 Styles into one. */


var mergeStyles = function mergeStyles(baseStyle) {
  for (var _len = arguments.length, mergeStyles = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    mergeStyles[_key - 1] = arguments[_key];
  }

  return function (theme, props, classes) {
    return mergeAll([getStyleRules(baseStyle, theme, props, classes)].concat(_toConsumableArray(mergeStyles.map(function (style) {
      return getStyleRules(style, theme, props, classes);
    }))));
  };
};
/**
 * (Deep) Merges styles conditionally into commonStyle if their given conditions are satisfied.
 * Conditional styles also take in optional _mediaQueryGenerator_, that would add media query
 * generated by it to the respective styles.
 */


var mergeStylesConditionally = function mergeStylesConditionally(commonStyle) {
  for (var _len2 = arguments.length, conditionalStyles = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    conditionalStyles[_key2 - 1] = arguments[_key2];
  }

  return function (theme, props, classes) {
    return mergeAll([getStyleRules(commonStyle, theme, props, classes)].concat(_toConsumableArray(conditionalStyles.filter(function (_ref) {
      var condition = _ref.condition;
      return condition(props);
    }).map(function (conditionalStyle) {
      return transformStyleRuleResponsively(conditionalStyle, theme, props, classes);
    }))));
  };
};
/**
 * (Deep) Merges 2 styles conditionally into ${commonStyle} if their conditions are satisfied.
 * Additionally, when styles' prop with key ${propNameForBreakpoint} is non null key (a breakpoint
 * or a number referring to screen width), then both styles will be displayed - the first style
 * displayed for screens with width smaller than the given breakpoint/screen width; the second style
 * will be applied for screens with width bigger than the given breakpoint/screen width.
 */


var mergeTwoConditionalStylesResponsively = function mergeTwoConditionalStylesResponsively(commonStyle, conditionalStylesWithoutMediaQuery1, conditionalStylesWithoutMediaQuery2, propNameForBreakpoint) {
  var conditionalStyles1 = addQueryGenerator(conditionalStylesWithoutMediaQuery1, propNameForBreakpoint, "down");
  var conditionalStyles2 = addQueryGenerator(conditionalStylesWithoutMediaQuery2, propNameForBreakpoint, "up");
  return mergeStylesConditionally(commonStyle, conditionalStyles1, conditionalStyles2);
};

var getStyleRules = function getStyleRules(style, theme, props, classes) {
  return typeof style !== "function" ? style : style(theme, props, classes);
};

var transformStyleRuleResponsively = function transformStyleRuleResponsively(_ref2, theme, props, classes) {
  var styles = _ref2.styles,
      mediaQueryGenerator = _ref2.mediaQueryGenerator;
  var styleRules = getStyleRules(styles, theme, props, classes);
  var transformedStyleRules = {};
  Object.keys(styleRules).forEach(function (key) {
    var transformedRule = Object.assign({}, styleRules[key]); // Shallow copy to avoid mutation

    if (mediaQueryGenerator) {
      var mediaQuery = mediaQueryGenerator(theme, props);
      if (mediaQuery) transformedRule = _defineProperty({}, mediaQuery, transformedRule);
    }

    transformedStyleRules[key] = transformedRule;
  });
  return transformedStyleRules;
};

var addQueryGenerator = function addQueryGenerator(conditionalStylesWithoutMediaQuery, propNameForBreakpoint, upOrDown) {
  return Object.assign(Object.assign({}, conditionalStylesWithoutMediaQuery), {
    condition: function condition(props) {
      // Do not use conditional style if down breakpoint is xs or 0 or below
      var breakpoint = props[propNameForBreakpoint];
      if ((breakpoint <= 0 || breakpoint === "xs") && upOrDown === "down") return false;
      return !!props[propNameForBreakpoint] || conditionalStylesWithoutMediaQuery.condition(props);
    },
    mediaQueryGenerator: function mediaQueryGenerator(theme, props) {
      var breakpointWidth = props[propNameForBreakpoint];
      if (!breakpointWidth) return null;

      if (typeof breakpointWidth !== "number") {
        breakpointWidth = theme.breakpoints.values[breakpointWidth];
      }

      if (breakpointWidth <= 0) return null;
      return theme.breakpoints[upOrDown](breakpointWidth);
    }
  });
};

export { makeStyles, mergeStyles, mergeStylesConditionally, mergeTwoConditionalStylesResponsively, withStyles };